/**
 * subscriptionsApi — acciones de suscripción vía payment (portal de pagos).
 *
 * Las acciones (cancelar, cambiar tarjeta) pasan por payment, que rutea al PSP
 * histórico de la suscripción. Se llama con el JWT de sesión de Clerk del staff
 * (payment valida @yooldigital.com) o, desde un servidor, con SERVICE_SECRET.
 * La URL de yoolpay se deriva del hostname en runtime (ver baseUrl.js).
 */

import { yoolpayBaseUrl } from './baseUrl.js';

const YOOLPAY_BASE_URL = yoolpayBaseUrl();

async function request(path, token, options = {}) {
  const res = await fetch(`${YOOLPAY_BASE_URL}${path}`, {
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...(token ? { Authorization: `Bearer ${token}` } : {}),
      ...(options.headers || {}),
    },
  });
  const body = await res.json().catch(() => ({}));
  if (!res.ok) {
    throw new Error(body?.error || `payment respondió ${res.status}`);
  }
  return body;
}

/** Cancela una suscripción (rutea al PSP histórico). `subscriptionId` = id interno. */
export async function cancelSubscription(token, subscriptionId, reason) {
  return request('/api/subscription-cancel', token, {
    method: 'POST',
    body: JSON.stringify({ subscriptionId, ...(reason ? { reason } : {}) }),
  });
}

/** Genera la URL de cambio de tarjeta. Devuelve `{ url }`. */
export async function generateChangeCardUrl(token, subscriptionId) {
  const body = await request('/api/subscription-change-card', token, {
    method: 'POST',
    body: JSON.stringify({ subscriptionId }),
  });
  return { url: body?.changeCardUrl || null };
}
